import React from 'react';
import { Helmet } from 'react-helmet';
import SeoLandingPage from './SeoLandingPage';
import RemainingLandingContent from './RemainingLandingContent';

const WhatsappAutomation = () => (
  <>
    <Helmet>
      <title>WhatsApp Automation for Business Messaging | HAWKTRION</title>
      <meta name="description" content="Automate WhatsApp messages from business events, customer actions, and scheduled workflows. Connect templates, CRM, and integrations with HAWKTRION." />
      <meta name="keywords" content="WhatsApp automation, WhatsApp business automation, WhatsApp workflow automation" />
      <meta name="robots" content="index,follow" />
      <link rel="canonical" href="https://waba.hawktrion.com/whatsapp-automation/" />
      <meta property="og:title" content="WhatsApp Automation for Business Messaging | HAWKTRION" />
      <meta property="og:description" content="Automate WhatsApp messages from business events, customer actions, and scheduled workflows. Connect templates, CRM, and integrations with HAWKTRION." />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://waba.hawktrion.com/whatsapp-automation/" />
      <meta property="og:image" content="https://waba.hawktrion.com/logo.png" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="WhatsApp Automation for Business Messaging | HAWKTRION" />
      <meta name="twitter:description" content="Automate WhatsApp messages from business events, customer actions, and scheduled workflows. Connect templates, CRM, and integrations with HAWKTRION." />
      <meta name="twitter:image" content="https://waba.hawktrion.com/logo.png" />
    </Helmet>
    <SeoLandingPage title="WhatsApp Automation for Business Workflows" hideCta>
      <RemainingLandingContent pageKey="automation" />
    </SeoLandingPage>
  </>
);

export default WhatsappAutomation;